import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CanMatch, Router } from '@angular/router';
import { AuthService } from 'client/app/shared/services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanMatch {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canMatch(): Observable<boolean> {
    const isAuthenticated = this.authService.isAuthenticated();

    if (!isAuthenticated) this.router.navigateByUrl('unauthorized');
    return of(isAuthenticated);
  }
}
